import React from 'react';
import FiltersProvider from 'providers/FiltersProvider';
import PeoplePopoverTrigger from './PeoplePopoverTrigger';
import LocalSpeaksTrigger from './LocalSpeaksTrigger';
import MoreFiltersTrigger from '../../Navbar/popovers/MoreFiltersPopover/MoreFiltersTrigger';
import AgendaPopoverTrigger from '../../Navbar/popovers/AgendaPopover/AgendaPopoverTrigger';
import SubNavbar from '../SubNavbar';
import FilterTags from './FilterTags';
import useIsMobile from 'hooks/useIsMobile';

const CSS = require('./ExperienceFilterSubNavbar.less');

interface ExperienceFilterSubNavbarProps {
  transparent?: boolean;
}

function ExperienceFilterSubNavbar({ transparent }: ExperienceFilterSubNavbarProps) {
  const isMobile = useIsMobile();
  return (
    <SubNavbar transparent={transparent}>
      <FiltersProvider>
        {({ filters, adults, children }) =>
          <div className={CSS.Filters}>
            <AgendaPopoverTrigger
              isMobile={isMobile}
              filters={filters}
            />
            <PeoplePopoverTrigger
              isMobile={isMobile}
              adultsFilter={adults}
              childrenFilter={children}
            />
            <LocalSpeaksTrigger
              selectedLanguages={filters.activeFilters.find(filter => filter.uid === 'languages.items[]')}
              isMobile={isMobile}
            />
            <MoreFiltersTrigger
              selectedFilters={filters.activeFilters}
              isMobile={isMobile}
            />
            {!isMobile &&
              <FilterTags activeFilters={filters.activeFilters} />
            }
          </div>
        }
      </FiltersProvider>
    </SubNavbar>
  );
}

export default ExperienceFilterSubNavbar;
